export default "__VITE_ASSET__CwlnF2KC__"